export const state = () => ({
  users: [],
  childLocations:[],
  selectedLocation:null
})
